(() => {
  const redirects = {
    '/collections/0405': '/products/0405',
    '/collections/1290': '/products/1290',
    '/collections/2000-1': '/products/2000-1',
    '/collections/2000-2': '/products/2000-2',
    '/collections/2000-3': '/products/2000-3',
    '/collections/2000-8': '/products/2000-8',
    '/collections/2000-9': '/products/2000-9',
    '/collections/2002': '/products/2002',
    '/collections/3000': '/products/3000',
    '/collections/3250': '/products/3250',
    '/collections/3350': '/products/3350',
    '/collections/4300': '/products/4300',
    '/collections/4500-quilt': '/products/4500-quilt',
    '/collections/5050': '/products/5050',
    '/collections/5311': '/products/5311',
    '/collections/6526-101': '/products/6526-101',
    '/collections/6526-104': '/products/6526-104',
    '/collections/6600': '/products/6600',
    '/collections/6610': '/products/6610',
    '/collections/6733': '/products/6733',
    '/collections/7450': '/products/7450',
    '/collections/7550': '/products/7550',
    '/collections/7650': '/products/7650',
    '/collections/8200': '/products/8200',
    '/collections/8210': '/products/8210',
    '/collections/8220': '/products/8220',
    '/collections/8300': '/products/8300',
    '/collections/8500': '/products/8500',
    '/collections/8660': '/products/8660',
    '/collections/9000-1': '/products/9000-1',
    '/collections/9000-4': '/products/9000-4',
    '/collections/9000-5': '/products/9000-5',
    '/collections/kf2500': '/products/kf2500',
    '/collections/tc8660': '/products/tc8660',
    '/blogs/journal/boys-girls-clothes-work-examples': '/blogs/journal/sewing-book-boys-girls-clothes-work-examples',
    '/blogs/journal/boys-girls-clothes-book-fabric-examples': '/blogs/journal/sewing-book-boys-girls-clothes-work-examples',
    '/blogs/journal/boys-girls-clothes-fabric-examples': '/blogs/journal/sewing-book-boys-girls-clothes-work-examples',
    '/blogs/journal/sewing-book-boys-girls-fabric-examples': '/blogs/journal/sewing-book-boys-girls-clothes-work-examples',
    '/blogs/journal/small-kids-praised-clothes-fabric-examples': '/blogs/journal/sewing-book-small-kids-praised-clothes-work-examples',
    '/blogs/journal/small-kids-handmade-clothes-fabric-examples': '/blogs/journal/sewing-book-small-kids-handmade-clothes-work-examples',
    '/blogs/journal/kids-clothes-lesson-book-fabric-examples': '/blogs/journal/sewing-book-kids-clothes-lesson-work-examples',
    '/blogs/journal/mama-kids-favorite-fabric-examples': '/blogs/journal/sewing-book-mama-kids-favorite-work-examples',
    '/blogs/journal/girls-everyday-clothes-series-fabric-examples': '/blogs/journal/sewing-book-girls-everyday-clothes-series-work-examples',
    '/blogs/journal/girls-everyday-clothes-fabric-examples': '/blogs/journal/sewing-book-girls-everyday-clothes-series-work-examples',
    '/blogs/journal/girls-everyday-clothes-revised-fabric-examples': '/blogs/journal/sewing-book-girls-everyday-clothes-series-work-examples',
    '/blogs/journal/kids-kimono-book-fabric-examples': '/blogs/journal/sewing-book-kids-kimono-work-examples',
    '/blogs/journal/girls-boys-everyday-clothes-fabric-examples': '/blogs/journal/sewing-book-girls-boys-everyday-clothes-work-examples',
    '/blogs/journal/sweet-clothes-series-fabric-examples': '/blogs/journal/sewing-book-sweet-clothes-series-work-examples',
    '/blogs/journal/doll-kids-handmade-clothes-fabric-examples': '/blogs/journal/sewing-book-doll-kids-handmade-clothes-work-examples',
    '/blogs/journal/cute-shape-kids-clothes-fabric-examples': '/blogs/journal/sewing-book-cute-shape-kids-clothes-work-examples',
    '/blogs/journal/easy-neat-looking-clothes-fabric-examples': '/blogs/journal/sewing-book-easy-neat-looking-clothes-work-examples',
    '/blogs/journal/simple-easy-everyday-clothes-fabric-examples': '/blogs/journal/sewing-book-simple-easy-everyday-clothes-work-examples',
    '/blogs/journal/little-kids-memory-clothes-fabric-examples': '/blogs/journal/sewing-book-little-kids-memory-clothes-work-examples',
    '/blogs/journal/boys-girls-handmade-gift-fabric-guide': '/blogs/journal/sewing-book-boys-girls-handmade-gift-work-examples',
    '/blogs/journal/boys-girls-handmade-gift-clothes-work-examples': '/blogs/journal/sewing-book-boys-girls-handmade-gift-work-examples',
    '/blogs/journal/boys-girls-handmade-gift-clothes-fabric-examples': '/blogs/journal/sewing-book-boys-girls-handmade-gift-work-examples',
    '/blogs/journal/90-130-kids-clothes-fabric-examples': '/blogs/journal/sewing-book-90-130-kids-clothes-work-examples',
    '/blogs/journal/haru-kids-clothes-fabric-examples': '/blogs/journal/sewing-book-haru-kids-clothes-work-examples',
    '/blogs/journal/girls-daily-clothes-fabric-examples': '/blogs/journal/sewing-book-girls-daily-clothes-work-examples',
    '/blogs/journal/sewing-book-fabric-examples': '/blogs/journal/sewing-book-work-examples',
  };

  const normalizedPath = window.location.pathname.replace(/\/$/, '');
  const target = redirects[normalizedPath];
  if (!target) return;

  const url = new URL(target, window.location.origin);
  url.search = window.location.search;
  window.location.replace(url.toString());
})();

// product-firstview-cart-order-8300-20260604
(function () {
  if (window.__productFirstviewCartOrder8300) return;
  window.__productFirstviewCartOrder8300 = true;
  if (window.location.pathname.replace(/\/$/, "") !== "/products/8300") return;

  function placeAfter(reference, node) {
    if (!reference || !node || !reference.parentNode) return;
    reference.parentNode.insertBefore(node, reference.nextSibling);
  }

  function fixOrder() {
    var list = document.querySelector("safe-sticky.product-info .product-info__block-list");
    if (!list) return;

    var sample = list.querySelector('.product-info__block-item[data-block-type="sample-request"]');
    var quantity = list.querySelector('.product-info__block-item[data-block-type="quantity-selector"]');
    var buy = list.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
    var roll = list.querySelector('.product-info__block-item[data-block-type="roll-ticket"]');

    if (sample && quantity && buy) {
      var sampleBeforeBuy = Boolean(sample.compareDocumentPosition(buy) & Node.DOCUMENT_POSITION_FOLLOWING);
      if (sampleBeforeBuy) {
        placeAfter(roll || buy, sample);
      }
    }

    if (quantity && buy) {
      quantity.querySelectorAll(".shipping-badge").forEach(function (badge) {
        if (!buy.contains(badge)) {
          placeAfter(buy.querySelector("product-form") || buy.firstElementChild, badge);
        }
      });
    }
  }

  function schedule() {
    fixOrder();
    [150, 500, 1200, 2500].forEach(function (delay) {
      window.setTimeout(fixOrder, delay);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedule, { once: true });
  } else {
    schedule();
  }

  document.addEventListener("shopify:section:load", fixOrder);
})();

(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const phoneOrderHtml = `
    <div class="product-assisted-order product-assisted-order--runtime">
      <p class="product-assisted-order__lead">ネット注文が不安な方は、お電話でもご注文できます。</p>
      <a class="product-assisted-order__phone" href="tel:0795224769" aria-label="電話で注文・相談する 0795-22-4769">
        <span>電話で注文・相談する</span>
        <strong>0795-22-4769</strong>
      </a>
      <p class="product-assisted-order__note">品番・色・数量をお伝えいただくとスムーズです。平日10:00-17:00</p>
    </div>
  `;

  const ensurePhoneOrderStyles = () => {
    if (document.getElementById('product-assisted-order-runtime-style')) return;

    const style = document.createElement('style');
    style.id = 'product-assisted-order-runtime-style';
    style.textContent = `
      .product-assisted-order{margin:.75rem 0;padding:14px;border:1px solid rgba(169,85,60,.24);border-radius:8px;background:#fffaf6}
      .product-assisted-order__lead{margin:0 0 10px;color:#3f352f;font-size:.95rem;font-weight:700;line-height:1.5}
      .product-assisted-order__phone{display:flex;width:100%;align-items:center;justify-content:center;gap:.45rem;flex-wrap:wrap;padding:12px 14px;border-radius:8px;background:#a9553c;color:#fff;font-weight:800;line-height:1.35;text-align:center;text-decoration:none}
      .product-assisted-order__phone:hover{color:#fff;opacity:.9}
      .product-assisted-order__phone strong{color:inherit;font-size:1.05em;white-space:nowrap}
      .product-assisted-order__note{margin:8px 0 0;color:#6c5b52;font-size:.82rem;line-height:1.45}
      @media (max-width:699px){.product-assisted-order{padding:14px 12px}.product-assisted-order__phone{padding:14px 12px;font-size:1.02rem}}
    `;
    document.head.appendChild(style);
  };

  const placePhoneOrderCta = () => {
    if (!/^\/products\//.test(window.location.pathname)) return;

    const productInfo = document.querySelector('safe-sticky.product-info');
    if (!productInfo) return;

    const buyButtons = productInfo.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
    if (!buyButtons) return;

    const nextElement = buyButtons.nextElementSibling;
    if (nextElement?.classList?.contains('product-assisted-order')) return;

    ensurePhoneOrderStyles();

    const currentPhoneBox = productInfo.querySelector('.product-info__block-item[data-block-type="contact-button"] .product-assisted-order');
    const sourceBox = currentPhoneBox?.cloneNode(true);
    const phoneBox = sourceBox || new DOMParser().parseFromString(phoneOrderHtml, 'text/html').body.firstElementChild;

    phoneBox.querySelector('.product-assisted-order__chat')?.remove();
    buyButtons.insertAdjacentElement('afterend', phoneBox);

    if (currentPhoneBox) {
      const contactBlock = currentPhoneBox.closest('.product-info__block-item[data-block-type="contact-button"]');
      const chatLink = currentPhoneBox.querySelector('.product-assisted-order__chat');
      if (contactBlock && chatLink) {
        chatLink.className = 'tcl-more__btn';
        contactBlock.replaceChildren(chatLink);
      }
    }
  };

  onReady(() => {
    placePhoneOrderCta();
    setTimeout(placePhoneOrderCta, 600);
  });
})();

(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const refreshHomepageHybridCarousel = () => {
    if (window.location.pathname !== '/' && window.location.pathname !== '') return;

    const currentSection = document.querySelector('.section-hybrid-carousel[id^="shopify-section-"]');
    if (!currentSection || currentSection.querySelector('a[href="/blogs/journal/sewing-book-work-examples"]')) return;

    const sectionId = currentSection.id.replace(/^shopify-section-/, '');
    const url = new URL(window.location.pathname || '/', window.location.origin);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('home_carousel_hydrate', Date.now().toString());

    fetch(url.toString(), { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        if (
          !html ||
          !html.includes('homepage-slider-sewing-book-work-examples-20260602-v2') ||
          !html.includes('/blogs/journal/sewing-book-work-examples')
        ) {
          return;
        }

        const freshSection = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('.section-hybrid-carousel');

        if (!freshSection) return;

        currentSection.replaceWith(freshSection);
        freshSection.querySelectorAll('script').forEach((script) => {
          const executable = document.createElement('script');
          Array.from(script.attributes).forEach((attribute) => {
            executable.setAttribute(attribute.name, attribute.value);
          });
          executable.textContent = script.textContent;
          document.body.appendChild(executable);
        });
      })
      .catch(() => {});
  };

  onReady(refreshHomepageHybridCarousel);
})();

(() => {
  if (window.location.pathname !== '/pages/cutting-request') return;

  const estimateButtonLabel = '無料お見積もりを依頼する';
  const submitLabels = new Set([estimateButtonLabel, 'Submit', 'Sign up', 'お見積もりを依頼する', '送信', '送信する']);
  const normalizeText = (text) => (text || '').replace(/\s+/g, ' ').trim();

  const patchVisibleCopy = () => {
    document.querySelectorAll('.cutting-request__form-lead h2').forEach((heading) => {
      if (normalizeText(heading.textContent) === '送信フォーム') {
        heading.textContent = '無料お見積もり依頼フォーム';
      }
    });

    document.querySelectorAll('.cutting-request__faq details p').forEach((paragraph) => {
      paragraph.textContent = paragraph.textContent.replace('実際の金額は送信内容を確認してから', '実際の金額はご依頼内容を確認してから');
    });
  };

  const injectFormStyles = (root) => {
    if (root.getElementById('cutting-request-form-styles')) return;

    const style = document.createElement('style');
    style.id = 'cutting-request-form-styles';
    style.textContent = `
      [data-cutting-request-submit="true"] {
        min-height: 52px !important;
        padding: 14px 22px !important;
        border-color: #a9553c !important;
        border-radius: 6px !important;
        background: #a9553c !important;
        color: #ffffff !important;
        font-weight: 700 !important;
        box-shadow: 0 10px 20px rgba(169, 85, 60, 0.18) !important;
        transition: background-color 0.18s ease, border-color 0.18s ease, transform 0.18s ease !important;
      }

      [data-cutting-request-submit="true"]:hover {
        border-color: #8b432f !important;
        background: #8b432f !important;
      }

      [data-cutting-request-submit="true"]:active {
        transform: translateY(1px) !important;
      }

      [data-cutting-request-submit="true"]:focus-visible {
        outline: 3px solid rgba(169, 85, 60, 0.28) !important;
        outline-offset: 2px !important;
      }
    `;
    root.appendChild(style);
  };

  const replaceNodeText = (root) => {
    const replacements = {
      'By signing up, you agree to receive marketing emails. View our privacy policy and terms of service for more info.': 'ご依頼内容を当店で確認し、裁断前に確認メールをお送りします。確認後に作業へ進みます。',
      'Submit': estimateButtonLabel,
      'Sign up': estimateButtonLabel,
      'お見積もりを依頼する': estimateButtonLabel,
      '送信': estimateButtonLabel,
      '送信する': estimateButtonLabel
    };

    const visit = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const normalized = normalizeText(node.nodeValue);
        if (replacements[normalized]) node.nodeValue = replacements[normalized];
        return;
      }

      node.childNodes.forEach(visit);
    };

    visit(root);
  };

  const patchSubmitButton = (root) => {
    root.querySelectorAll('button, input[type="submit"]').forEach((button) => {
      const text = normalizeText(button.textContent || button.value || '');
      const hasSubmitType = button.matches('button[type="submit"], input[type="submit"]');
      const isSubmit = hasSubmitType || submitLabels.has(text);
      if (!isSubmit) return;

      if (button.tagName === 'INPUT') {
        button.value = estimateButtonLabel;
      } else if (text !== estimateButtonLabel) {
        button.textContent = estimateButtonLabel;
      }

      button.dataset.cuttingRequestSubmit = 'true';
    });
  };

  const patchForms = () => {
    document.querySelectorAll('shopify-forms-embed').forEach((embed) => {
      const root = embed.shadowRoot;
      if (!root) return;

      replaceNodeText(root);
      patchSubmitButton(root);
      injectFormStyles(root);
    });
  };

  const hydrate = () => {
    patchVisibleCopy();
    patchForms();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate, { once: true });
  } else {
    hydrate();
  }
  const cuttingRequestObserver = new MutationObserver(hydrate);
  cuttingRequestObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  window.setTimeout(() => cuttingRequestObserver.disconnect(), 10000);

  [250, 750, 1500, 3000].forEach((delay) => window.setTimeout(hydrate, delay));
})();

document.addEventListener('change', (e) => {
  if (!e.target.closest('variant-picker')) return;
  const section = document.querySelector('product-gallery')?.closest('.shopify-section');
  if (!section) return;
  const sectionTop = section.offsetTop;
  const headerH = document.querySelector('.shopify-section-group-header-group')?.offsetHeight || 0;
  window.scrollTo({ top: Math.max(0, sectionTop - headerH), behavior: 'smooth' });
}, true);

(function syncProductGalleryToSelectedVariant() {
  if (!window.location.pathname.startsWith('/products/')) return;

  const runAfterRerender = (callback) => {
    requestAnimationFrame(() => requestAnimationFrame(callback));
    setTimeout(callback, 250);
  };

  const findGalleryForVariant = (formId, mediaId) => {
    const formSelector = formId && window.CSS?.escape
      ? `product-gallery[form="${CSS.escape(formId)}"]`
      : 'product-gallery';

    return Array.from(document.querySelectorAll(formSelector))
      .find((gallery) => gallery.querySelector(`[data-media-id="${mediaId}"]`));
  };

  const onVariantChange = (event) => {
    if (event.__productGallerySyncHandled) return;
    event.__productGallerySyncHandled = true;

    const mediaId = event.detail?.variant?.featured_media?.id;
    if (!mediaId) return;

    runAfterRerender(() => {
      const gallery = findGalleryForVariant(event.detail?.formId, mediaId);
      const target = gallery?.querySelector(`[data-media-id="${mediaId}"]`);
      if (!gallery || !target || target.hasAttribute('hidden')) return;

      const carousel = gallery.querySelector('.product-gallery__carousel');
      if (carousel?.isScrollable && typeof carousel.select === 'function') {
        const index = carousel.cells.indexOf(target);
        if (index >= 0) carousel.select(index, { instant: true });
      } else {
        target.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    });
  };

  const boundForms = new WeakSet();

  const bindVariantForms = (root = document) => {
    root.querySelectorAll?.('product-gallery[form], variant-picker[form-id]').forEach((element) => {
      const formId = element.getAttribute('form') || element.getAttribute('form-id');
      const form = formId ? document.forms[formId] : null;
      if (!form || boundForms.has(form)) return;

      boundForms.add(form);
      form.addEventListener('variant:change', onVariantChange);
    });
  };

  bindVariantForms();
  document.addEventListener('variant:change', onVariantChange);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) bindVariantForms(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  let renderTimer = null;

  const onSectionRerendered = () => {
    const nav = document.querySelector('product-gallery-navigation');
    if (nav && nav.scrollWidth > nav.clientWidth) {
      const current = nav.querySelector('[aria-current="true"]');
      if (current) {
        const targetLeft = current.offsetLeft - nav.clientWidth / 2 + current.clientWidth / 2;
        nav.scrollLeft = Math.max(0, Math.min(targetLeft, nav.scrollWidth - nav.clientWidth));
      }
    }
  };

  const observer = new MutationObserver(() => {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(onSectionRerendered, 600);
  });

  const startObserving = () => {
    const gallerySection = document.querySelector('product-gallery')?.closest('.shopify-section');
    if (gallerySection) {
      observer.observe(gallerySection, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();

(function productVideoPlacementCacheFix() {
  if (!window.location.pathname.startsWith('/products/')) return;

  const moveProductVideo = () => {
    const extra = document.getElementById('product-extra-information');
    const description = extra && extra.querySelector('.product-content-below-gallery__description');

    if (!extra || !description) return;

    const placedVideo = extra.querySelector('.product-metafield-video-block, .shopify-section--product-metafield-video');

    if (placedVideo) {
      if (description.compareDocumentPosition(placedVideo) & Node.DOCUMENT_POSITION_PRECEDING) {
        return;
      }

      placedVideo.setAttribute('data-product-video-placement-cache-fix', 'true');
      description.insertAdjacentElement('beforebegin', placedVideo);
      return;
    }

    const rightColumnVideo = document.querySelector('.product-info__block-item[data-block-type="product-video-metafield"]');
    const standaloneVideo = document.querySelector('.shopify-section--product-metafield-video');
    const videoNode = rightColumnVideo || standaloneVideo;

    if (!videoNode || extra.contains(videoNode)) return;

    videoNode.setAttribute('data-product-video-placement-cache-fix', 'true');
    description.insertAdjacentElement('beforebegin', videoNode);
  };

  const schedule = () => {
    moveProductVideo();
    setTimeout(moveProductVideo, 100);
    setTimeout(moveProductVideo, 500);
    setTimeout(moveProductVideo, 1500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  const observer = new MutationObserver(moveProductVideo);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

(function productMetafieldVideoBrightControls() {
  const path = window.location.pathname;
  if (!path.startsWith('/products/') && path !== '/pages/product-video-gallery') return;

  const mobileQuery = window.matchMedia('(max-width: 767px)');

  const setPlayerMode = (player) => {
    const video = player.querySelector('[data-product-video]');
    const toggle = player.querySelector('[data-product-video-toggle]');
    if (!video || !toggle) return;

    if (!player.dataset.nativeControls) {
      player.dataset.nativeControls = video.hasAttribute('controls') ? 'true' : 'false';
    }

    if (mobileQuery.matches) {
      video.removeAttribute('controls');
      video.controls = false;
      player.classList.add('is-custom-controls');
    } else {
      if (player.dataset.nativeControls === 'true') {
        video.setAttribute('controls', '');
        video.controls = true;
      }
      player.classList.remove('is-custom-controls', 'is-playing');
    }
  };

  const pauseOtherVideos = (currentVideo) => {
    document.querySelectorAll('[data-product-video]').forEach((video) => {
      if (video !== currentVideo && !video.paused) {
        video.pause();
      }
    });
  };

  const bindPlayer = (player) => {
    const video = player.querySelector('[data-product-video]');
    const toggle = player.querySelector('[data-product-video-toggle]');
    if (!video || !toggle) return;

    setPlayerMode(player);

    if (player.dataset.brightControlsBound === 'true') return;
    player.dataset.brightControlsBound = 'true';

    const update = () => {
      const isPlaying = !video.paused && !video.ended;
      player.classList.toggle('is-playing', isPlaying);
      toggle.setAttribute('aria-label', isPlaying ? '動画を一時停止' : '動画を再生');
    };

    const togglePlayback = async () => {
      if (!mobileQuery.matches) return;

      if (video.paused || video.ended) {
        pauseOtherVideos(video);
        try {
          await video.play();
        } catch {
          video.setAttribute('controls', '');
          video.controls = true;
        }
      } else {
        video.pause();
      }

      update();
    };

    toggle.addEventListener('click', (event) => {
      if (!mobileQuery.matches) return;
      event.preventDefault();
      event.stopPropagation();
      togglePlayback();
    });

    video.addEventListener('click', (event) => {
      if (!mobileQuery.matches) return;
      event.preventDefault();
      togglePlayback();
    });

    video.addEventListener('play', update);
    video.addEventListener('pause', update);
    video.addEventListener('ended', update);
    update();
  };

  const hydrate = () => {
    document.querySelectorAll('[data-product-video-player]').forEach(bindPlayer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate, { once: true });
  } else {
    hydrate();
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', hydrate);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(hydrate);
  }

  const observer = new MutationObserver(hydrate);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('quantity-selector[data-multiplier]').forEach((selector) => {
    const multiplier = parseInt(selector.dataset.multiplier || '1', 10);
    const input = selector.querySelector('input.quantity-selector__input');
    const display = selector.querySelector('.quantity-display');

    if (!input || !display) return;

    const updateDisplay = () => {
      const value = parseInt(input.value || '1', 10);
      display.textContent = value * multiplier;
    };

    input.addEventListener('input', updateDisplay);
    input.addEventListener('change', updateDisplay);
    updateDisplay(); // 初期表示反映
  });
});

(function backInStockAlert() {
  const KLAVIYO_REVISION = '2026-04-15';

  const setMessage = (root, message, state) => {
    const messageElement = root.querySelector('[data-restock-message]');
    if (messageElement) messageElement.textContent = message;
    root.dataset.state = state;
  };

  const getErrorMessage = async (response) => {
    try {
      const body = await response.json();
      const detail = body?.errors?.[0]?.detail || body?.errors?.[0]?.title;
      if (detail && /invalid email/i.test(detail)) {
        return 'メールアドレスをご確認ください。';
      }
    } catch {
      // Use the generic storefront message below.
    }

    return '登録できませんでした。時間をおいてもう一度お試しください。';
  };

  const submitRestockAlert = async (root) => {
    const input = root.querySelector('[data-restock-email]');
    const submitButton = root.querySelector('[data-restock-submit]');
    const companyId = root.dataset.companyId;
    const variantId = root.dataset.variantId;

    if (!input || !submitButton || !companyId || !variantId) return;

    if (!input.value.trim() && root.dataset.customerEmail) {
      input.value = root.dataset.customerEmail;
    }

    if (!input.checkValidity()) {
      input.reportValidity();
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = '登録しています';
    setMessage(root, '', 'loading');

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: input.value.trim()
              }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    };

    try {
      const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: KLAVIYO_REVISION
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok && response.status !== 202) {
        throw new Error(await getErrorMessage(response));
      }

      root.querySelector('[data-restock-fields]')?.setAttribute('hidden', '');
      setMessage(root, '登録しました。再入荷したらメールでお知らせします。', 'success');

      window.dataLayer?.push({
        event: 'back_in_stock_signup',
        product_id: root.dataset.productId,
        product_handle: root.dataset.productHandle,
        variant_id: root.dataset.variantId
      });
    } catch (error) {
      setMessage(root, error.message || '登録できませんでした。時間をおいてもう一度お試しください。', 'error');
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = '通知を登録する';
    }
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-restock-open]');
    if (openButton) {
      const root = openButton.closest('[data-restock-alert]');
      const fields = root?.querySelector('[data-restock-fields]');
      const input = root?.querySelector('[data-restock-email]');

      if (!root || !fields || !input) return;

      fields.hidden = false;
      if (!input.value && root.dataset.customerEmail) {
        input.value = root.dataset.customerEmail;
      }
      input.focus();
      return;
    }

    const submitButton = event.target.closest('[data-restock-submit]');
    if (submitButton) {
      const root = submitButton.closest('[data-restock-alert]');
      if (root) submitRestockAlert(root);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || !event.target.matches('[data-restock-email]')) return;

    const root = event.target.closest('[data-restock-alert]');
    if (!root) return;

    event.preventDefault();
    submitRestockAlert(root);
  });
})();

(function refreshWafukuRecommendedArticles() {
  const sectionId = 'template--26755958767909__prev-next-blog-posts';
  const targetPath = '/blogs/hint/wafuku';

  if (window.location.pathname !== targetPath) return;

  const refresh = () => {
    const section = document.getElementById(`shopify-section-${sectionId}`);
    if (!section || section.querySelector('a[href="/blogs/journal/hakama-pants"]')) return;

    fetch(`${targetPath}?sections=${sectionId}`, { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((sections) => {
        const html = sections && sections[sectionId];
        if (!html || !html.includes('/blogs/journal/hakama-pants')) return;

        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        const freshSection = wrapper.firstElementChild;

        if (freshSection) {
          section.replaceWith(freshSection);
        }
      })
      .catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();

(function normalizeProductVideoGuideLinks() {
  if (window.location.pathname !== '/' && window.location.pathname !== '') return;

  const oldPath = '/pages/product-videos';
  const newPath = '/pages/product-video-gallery?view=product-video-gallery';

  const updateLinks = () => {
    document.querySelectorAll('.home-product-video-guide a[href]').forEach((link) => {
      const href = link.getAttribute('href');
      let url;

      try {
        url = new URL(href, window.location.origin);
      } catch (error) {
        return;
      }

      if (url.pathname === oldPath || url.pathname === '/pages/product-video-gallery') {
        link.setAttribute('href', newPath);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateLinks, { once: true });
  } else {
    updateLinks();
  }

  const observer = new MutationObserver(updateLinks);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  const targetPath = '/products/13-002';
  const marker = 'kijimaru-dog-pattern-13-002-v1';

  if (window.location.pathname !== targetPath) return;

  const runScripts = (scope) => {
    scope.querySelectorAll('script').forEach((script) => {
      const executable = document.createElement('script');
      Array.from(script.attributes).forEach((attribute) => {
        executable.setAttribute(attribute.name, attribute.value);
      });
      executable.textContent = script.textContent;
      document.body.appendChild(executable);
    });
  };

  const syncHead = (doc) => {
    const freshTitle = doc.querySelector('title');
    if (freshTitle) {
      document.title = freshTitle.textContent;
    }

    ['description', 'twitter:title', 'twitter:description'].forEach((name) => {
      const current = document.querySelector(`meta[name="${name}"]`);
      const fresh = doc.querySelector(`meta[name="${name}"]`);
      if (current && fresh) current.setAttribute('content', fresh.getAttribute('content') || '');
    });

    ['og:title', 'og:description'].forEach((property) => {
      const current = document.querySelector(`meta[property="${property}"]`);
      const fresh = doc.querySelector(`meta[property="${property}"]`);
      if (current && fresh) current.setAttribute('content', fresh.getAttribute('content') || '');
    });
  };

  const hydrate = () => {
    if (document.querySelector(`.${marker}`)) return;

    const currentSection = document.querySelector('.shopify-section--main-product');
    if (!currentSection) return;

    fetch(`${targetPath}?variant=51197194010917&dog13_hydrate=${Date.now()}`, {
      credentials: 'same-origin',
    })
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        if (!html || !html.includes(marker)) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const freshSection = doc.querySelector('.shopify-section--main-product');
        if (!freshSection) return;

        currentSection.replaceWith(freshSection);
        syncHead(doc);
        runScripts(freshSection);
      })
      .catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate, { once: true });
  } else {
    hydrate();
  }
})();

(function hydrateProductVideoCatalogFromFreshPage() {
  if (window.location.pathname !== '/pages/product-video-gallery') return;

  const refresh = () => {
    const currentSection = document.querySelector('.shopify-section--product-video-only-gallery');
    if (!currentSection) return;
    if (currentSection.innerHTML.includes('n2sNrqPWZR8')) return;

    const sectionId = currentSection.id.replace(/^shopify-section-/, '');
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('catalog_hydrate', Date.now().toString());

    fetch(`${url.pathname}${url.search}`, { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        if (!html || !html.includes('n2sNrqPWZR8')) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const freshSection = doc.querySelector('.shopify-section--product-video-only-gallery');
        if (!freshSection) return;

        currentSection.replaceWith(freshSection);

        freshSection.querySelectorAll('script').forEach((script) => {
          const executable = document.createElement('script');

          Array.from(script.attributes).forEach((attribute) => {
            executable.setAttribute(attribute.name, attribute.value);
          });

          executable.textContent = script.textContent;
          document.body.appendChild(executable);
        });
      })
      .catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();

(function keepProductVideoShortsFromUpscaling() {
  if (window.location.pathname !== '/pages/product-video-gallery') return;

  const applyQualityStyle = () => {
    if (!document.querySelector('.product-video-only--shorts')) return;
    if (document.getElementById('product-video-shorts-quality-style')) return;

    const style = document.createElement('style');
    style.id = 'product-video-shorts-quality-style';
    style.textContent = [
      '.product-video-only--shorts .product-video-only__media video,',
      '.product-video-only--shorts .product-video-only__media img {',
      'object-fit: contain !important;',
      'object-position: center !important;',
      '}',
    ].join('');
    document.head.appendChild(style);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyQualityStyle, { once: true });
  } else {
    applyQualityStyle();
  }

  const observer = new MutationObserver(applyQualityStyle);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

(function normalizeTopNewArrivalLinks() {
  if (window.location.pathname !== '/' && window.location.pathname !== '') return;

  const targetPath = '/collections/new-arrivals?sort_by=created-desc';

  const isNewArrivalCta = (link) => {
    const text = (link.textContent || '').replace(/\s+/g, ' ').trim();
    return text.includes('新着をもっと見る') || Boolean(link.closest('[class*="new-arrivals-cta"]'));
  };

  const shouldRewrite = (link) => {
    if (!isNewArrivalCta(link)) return false;

    const rawHref = link.getAttribute('href') || '';
    if (!rawHref) return false;

    let url;
    try {
      url = new URL(rawHref, window.location.origin);
    } catch (error) {
      return false;
    }

    return url.pathname === '/collections/all' || url.pathname === '/collections/new-arrivals';
  };

  const updateLinks = () => {
    document.querySelectorAll('a[href]').forEach((link) => {
      if (shouldRewrite(link)) {
        link.setAttribute('href', targetPath);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateLinks, { once: true });
  } else {
    updateLinks();
  }

  const observer = new MutationObserver(updateLinks);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

(function trackHomeSamplebookCtaClicks() {
  const eventName = 'samplebook_home_cta_click';

  const isHomePage = () => window.location.pathname === '/' || window.location.pathname === '';
  if (!isHomePage()) return;

  const isSamplebookCta = (link) => {
    if (link.matches('[data-samplebook-home-cta]')) return true;
    if (!link.closest('#shopify-section-template--26755976757541__samplebook_fixed, .mf-kore')) return false;

    const url = new URL(link.getAttribute('href') || '', window.location.origin);
    return url.pathname === '/collections/samplebook';
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const link = target?.closest('a[href]');
    if (!link || !isSamplebookCta(link)) return;

    const params = {
      section_id: link.closest('[id^="shopify-section-"]')?.id || '',
      link_url: link.getAttribute('href') || '',
      link_text: link.textContent.replace(/\s+/g, ' ').trim(),
      rollout_treatment_ids: document.body?.dataset?.treatmentIds || ''
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...params
    });
  });
})();

(() => {
  const campaignStart = Date.parse('2026-06-01T11:00:00Z');
  const campaignEnd = Date.parse('2026-06-04T11:00:00Z');
  const now = Date.now();

  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const salePagePath = '/pages/shoka-nunoichi-202606';
  const saleCollectionPath = '/collections/shoka-nunoichi-202606';
  const saleView = 'shoka-nunoichi-202606-v4';
  const endedTitle = '初夏の布市は終了しました | 生地のマルイシ';
  const endedDescription = '初夏の布市は2026年6月4日(木)20:00に終了しました。現在は通常価格での販売です。';

  const removeSaleChrome = () => {
    document.querySelectorAll('.badge--shoka-nunoichi, .shoka-nunoichi-product-notice').forEach((node) => {
      node.remove();
    });

    document.querySelectorAll('.shoka-nunoichi-bar').forEach((bar) => {
      const section = bar.closest('.shopify-section--shoka-nunoichi-announcement');
      (section || bar).remove();
    });

    document.querySelectorAll('.shoka-nunoichi-home').forEach((section) => {
      const wrapper = section.closest('.shopify-section');
      (wrapper || section).remove();
    });

    document.querySelectorAll(`a[href*="${salePagePath}"], a[href*="${saleCollectionPath}"]`).forEach((link) => {
      let url;

      try {
        url = new URL(link.getAttribute('href') || '', window.location.origin);
      } catch (error) {
        return;
      }

      if (url.pathname !== salePagePath && url.pathname !== saleCollectionPath) {
        return;
      }

      const saleCard = link.closest('.hybrid-carousel__card');
      if (saleCard) {
        saleCard.remove();
      }
    });
  };

  const applyEndedMetadata = () => {
    if (window.location.pathname !== salePagePath && window.location.pathname !== saleCollectionPath) {
      return;
    }

    document.title = endedTitle;

    const upsertMeta = (selector, attribute, value) => {
      let node = document.head.querySelector(selector);

      if (!node) {
        node = document.createElement('meta');
        node.setAttribute(attribute, selector.match(/"([^"]+)"/)?.[1] || '');
        document.head.appendChild(node);
      }

      node.setAttribute('content', value);
    };

    upsertMeta('meta[name="description"]', 'name', endedDescription);
    upsertMeta('meta[property="og:title"]', 'property', '初夏の布市は終了しました');
    upsertMeta('meta[property="og:description"]', 'property', endedDescription);
    upsertMeta('meta[name="twitter:title"]', 'name', '初夏の布市は終了しました');
    upsertMeta('meta[name="twitter:description"]', 'name', endedDescription);
  };

  const rewriteSaleLinks = () => {
    document.querySelectorAll(`a[href*="${saleCollectionPath}"], a[href^="${salePagePath}"]`).forEach((link) => {
      let url;

      try {
        url = new URL(link.getAttribute('href') || '', window.location.origin);
      } catch (error) {
        return;
      }

      if (url.pathname !== saleCollectionPath && url.pathname !== salePagePath) {
        return;
      }

      url.pathname = salePagePath;
      url.searchParams.set('view', saleView);
      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    });
  };

  if (now >= campaignStart && now < campaignEnd) {
    onReady(rewriteSaleLinks);
    new MutationObserver(rewriteSaleLinks).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (now < campaignStart) {
    onReady(removeSaleChrome);
    return;
  }

  if (now >= campaignEnd) {
    onReady(() => {
      removeSaleChrome();
      applyEndedMetadata();

      if (window.location.pathname === salePagePath || window.location.pathname === saleCollectionPath) {
        const salePage = document.querySelector('.shoka-sale-page');

        if (salePage) {
          if (!document.getElementById('shoka-nunoichi-ended-style')) {
            const style = document.createElement('style');
            style.id = 'shoka-nunoichi-ended-style';
            style.textContent = [
              '.shoka-sale-page__ended{display:grid;justify-items:center;gap:14px;max-width:760px;margin:0 auto;padding:58px var(--page-outer-spacing,20px) 64px;text-align:center}',
              '.shoka-sale-page__ended h1{margin:0;color:#263c35;font-size:38px;line-height:1.25;letter-spacing:0}',
              '.shoka-sale-page__ended-lead{max-width:34em;margin:0;color:#53625d;font-size:14px;line-height:1.9}',
              '.shoka-sale-page__ended-button{display:inline-flex;align-items:center;justify-content:center;min-height:40px;padding:9px 16px;border-radius:6px;background:#263c35;color:#fff;font-size:13px;font-weight:700;line-height:1.4;text-decoration:none}'
            ].join('');
            document.head.appendChild(style);
          }

          salePage.innerHTML = `
            <div class="shoka-sale-page__ended">
              <p class="shoka-sale-page__eyebrow">終了しました</p>
              <h1 id="shoka-sale-page-title">初夏の布市は終了しました</h1>
              <p class="shoka-sale-page__ended-lead">このセールは2026年6月4日(木)20:00に終了しました。現在は通常価格での販売です。</p>
              <a class="shoka-sale-page__ended-button" href="/">トップページへ戻る</a>
            </div>
          `;
        }
      }
    });

    new MutationObserver(removeSaleChrome).observe(document.documentElement, { childList: true, subtree: true });

    return;
  }

  const fallbackLabel = '6/4 20:00まで';
  const fallbackText = '初夏の布市 10%OFF｜カートで自動割引';

  const fallbackBannerHtml = `
    <div class="shopify-section shopify-section-group-header-group shopify-section--shoka-nunoichi-announcement" data-shoka-nunoichi-fallback>
      <aside class="shoka-nunoichi-bar" aria-label="初夏の布市のお知らせ">
        <a class="shoka-nunoichi-bar__link" href="/pages/shoka-nunoichi-202606?view=shoka-nunoichi-202606-v4&utm_source=site&utm_medium=topbar&utm_campaign=shoka_nunoichi_202606&utm_content=sitewide_bar">
          <span class="shoka-nunoichi-bar__label">${fallbackLabel}</span>
          <span class="shoka-nunoichi-bar__text">${fallbackText}</span>
        </a>
      </aside>
      <style>
        .shoka-nunoichi-bar{background:#f8f1e8;border-bottom:1px solid rgba(63,58,57,.12)}
        .shoka-nunoichi-bar__link{display:flex;justify-content:center;align-items:center;gap:10px;min-height:42px;padding:9px 16px;color:#3f3a39;font-family:"Ryo Gothic PlusN",sans-serif;font-size:13px;line-height:1.45;text-decoration:none;text-align:center}
        .shoka-nunoichi-bar__label{flex:0 0 auto;padding:3px 8px;border:1px solid rgba(63,58,57,.22);border-radius:4px;background:#fff;font-size:12px;font-weight:600}
        .shoka-nunoichi-bar__text{font-weight:600}
        @media screen and (max-width:699px){.shoka-nunoichi-bar__link{flex-wrap:wrap;gap:6px 8px;padding:8px 12px;font-size:12px}}
      </style>
    </div>
  `;

  const insertHtml = (html, anchor) => {
    if (!html || document.querySelector('.shoka-nunoichi-bar')) {
      return;
    }

    const template = document.createElement('template');
    template.innerHTML = html.trim();
    const node = template.content.firstElementChild;

    if (node) {
      anchor.insertAdjacentElement('beforebegin', node);
    }
  };

  const hydrateSaleAnnouncement = async () => {
    if (document.querySelector('.shoka-nunoichi-bar')) {
      return;
    }

    const anchor = document.querySelector('[id^="shopify-section-sections--"][id$="__announcement_review_coupon"]')
      || document.querySelector('[id^="shopify-section-sections--"][id$="__header"]');

    if (!anchor?.id) {
      return;
    }

    const sectionId = anchor.id
      .replace(/^shopify-section-/, '')
      .replace(/__(announcement_review_coupon|header)$/, '__shoka_nunoichi_202606_announcement');

    try {
      const url = new URL(window.location.pathname, window.location.origin);
      url.searchParams.set('sections', sectionId);

      const response = await fetch(url.toString(), { credentials: 'same-origin' });
      const sections = response.ok ? await response.json() : {};
      insertHtml(sections[sectionId] || fallbackBannerHtml, anchor);
    } catch (error) {
      insertHtml(fallbackBannerHtml, anchor);
    }
  };

  onReady(hydrateSaleAnnouncement);
})();

(function hydrateCollectionChoiceGuideTabsFromCachedHtml() {
  const guideByPath = {
    '/collections/cotton-polyester-blend': {
      collectionTitle: 'すべての綿ポリ(T/C)',
      cards: [
        {
          group: 'map',
          badge: '生地マップ',
          title: '厚みとハリの位置を見る',
          text: '形を出す生地、標準、薄手の違いを地図で確認できます。迷った時の根拠として見るための小さな参照です。',
          link: '/blogs/journal/fabric-map',
          label: '生地マップを見る',
          image: '//kijimaru.jp/cdn/shop/files/kijimap-1a.png?v=1761011921&width=720',
          alt: '綿ポリ生地の厚みとハリを比較した生地マップ'
        },
        {
          group: 'purpose',
          badge: 'まず見る定番',
          title: 'まずは綿ポリダンガリー',
          text: '入園グッズ、パンツ、エプロン、袋物まで幅広く使える定番です。用途がまだ広い時は、ここから比較すると絞りやすくなります。',
          link: '/products/4500',
          label: '綿ポリダンガリーを見る'
        },
        {
          group: 'purpose',
          badge: '薄手・軽さ',
          title: 'シャツや軽い作品なら薄手も候補',
          text: '軽さ、乾きやすさ、きれいな表情を優先する時は、ブロードやポプリンなど薄手の綿ポリも比較候補になります。',
          link: '/products/8300',
          label: '綿ポリブロードを見る'
        },
        {
          group: 'texture',
          badge: '服・やわらかめ',
          title: '落ち感や肌あたりを優先',
          text: 'ワンピース、ブラウス、子ども服など、硬さを抑えたい時はソフトダンガリー系から見ると選びやすくなります。',
          link: '/collections/cotton-poly-soft-dungaree',
          label: 'ソフトダンガリーを見る'
        },
        {
          group: 'texture',
          badge: 'ハリを出す',
          title: '形を保ちたいならツイル系',
          text: 'パンツ、バッグ、切り替え布など、完成後の形を出したい作品は、やわらかさよりハリと厚みを優先して選びます。',
          link: '/collections/cotton-poly-twill',
          label: '綿ポリツイルを見る'
        },
        {
          group: 'wrinkle',
          badge: 'シワ対策',
          title: 'アイロンの手間を減らしたい時',
          text: 'ブロード、コードレーン、ラミネート、バニランは特にシワに強い位置。毎日洗うものは、見た目だけでなく洗濯後の扱いやすさで選びます。',
          link: '/collections/wrinkle-resistant',
          label: 'シワに強い生地を見る',
          image: '//kijimaru.jp/cdn/shop/files/kijimap-4.png?v=1761011855&width=720',
          alt: '綿ポリ生地の厚みとシワへの強さを比較した生地マップ'
        }
      ]
    },
    '/collections/cotton': {
      collectionTitle: 'すべてのコットン',
      cards: [
        {
          group: 'map',
          badge: '生地マップ',
          title: '厚みとハリの位置を見る',
          text: 'コットンは種類の幅が広いので、帆布・キルト・シーチング・ガーゼなどの位置関係を地図で確認できます。',
          link: '/blogs/journal/fabric-map',
          label: 'コットン生地マップを見る',
          image: '//kijimaru.jp/cdn/shop/files/kijimap-2.png?v=1761011855&width=720',
          alt: 'コットン生地の厚みとハリを比較した生地マップ'
        },
        {
          group: 'purpose',
          badge: '服・小物',
          title: '普段使いは中厚地から見る',
          text: '服、小物、カバー類など広く使うなら、シーチング、ダンガリー、ブロード、ツイルあたりを用途と厚みで比べます。',
          link: '/collections/cotton-dungaree',
          label: 'コットンダンガリーを見る'
        },
        {
          group: 'purpose',
          badge: '形を出す',
          title: 'バッグや底布なら帆布・キルト',
          text: 'しっかり立たせたい作品はハリと厚みが必要です。8号帆布、11号帆布、キルトは、完成した時の形を作りやすい生地です。',
          link: '/collections/cotton-canvas',
          label: '帆布を見る'
        },
        {
          group: 'texture',
          badge: '天然素材感',
          title: '風合いを優先するならコットン',
          text: '肌ざわりやナチュラルな表情を重視する時に向いています。縮みやシワを許容できる作品かも一緒に見てください。',
          link: '/collections/cotton-polyester-blend',
          label: '綿ポリも比較する'
        },
        {
          group: 'texture',
          badge: 'やわらかさ',
          title: '肌ざわりならガーゼ・タオル・レノクロス',
          text: 'ベビー用品、ハンカチ、軽い服など、やわらかさを活かしたい時は厚みだけでなく手触りの方向で選ぶと失敗しにくくなります。',
          link: '/collections/cotton-double-gauze',
          label: 'ダブルガーゼを見る'
        },
        {
          group: 'wrinkle',
          badge: 'シワ・縮み',
          title: '毎日洗うものは綿ポリも比較',
          text: 'コットンの風合いを優先するか、シワや洗濯後の扱いやすさを優先するかで選び分けます。服や通園通学品は綿ポリも候補です。',
          link: '/collections/cotton-polyester-blend',
          label: '綿ポリを見る'
        }
      ]
    }
  };

  const labels = {
    purpose: '用途から',
    texture: '質感から',
    wrinkle: 'シワに強い',
    map: '地図で見る'
  };

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char]));

  const injectStyle = () => {
    if (document.getElementById('collection-choice-guide-tabs-fallback-style')) return;

    const style = document.createElement('style');
    style.id = 'collection-choice-guide-tabs-fallback-style';
    style.textContent = `
      .shopify-section--collection-choice-guide .collection-choice-guide{background:#f7faf8;border-block:1px solid #dbe7e0}
      .shopify-section--collection-choice-guide .collection-choice-guide__inner{display:grid;grid-template-columns:minmax(220px,.78fr) minmax(0,1.7fr);gap:24px;align-items:start}
      .shopify-section--collection-choice-guide .collection-choice-guide__tabs{display:flex;flex-wrap:wrap;gap:4px;width:fit-content;max-width:100%;margin-top:18px;padding:4px;background:#eef5f1;border:1px solid #d8e5dd;border-radius:8px}
      .shopify-section--collection-choice-guide .collection-choice-guide__tab{appearance:none;min-height:34px;padding:7px 10px;color:#52615d;background:transparent;border:0;border-radius:6px;font:inherit;font-size:12px;font-weight:700;line-height:1.3;letter-spacing:0;cursor:pointer}
      .shopify-section--collection-choice-guide .collection-choice-guide__tab[aria-selected=true]{color:#2f6f73;background:#fff;box-shadow:0 1px 4px rgba(63,58,57,.08)}
      .shopify-section--collection-choice-guide .collection-choice-guide__grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));gap:12px;overflow:visible;margin-inline:0;padding-inline:0}
      .shopify-section--collection-choice-guide .collection-choice-guide__card[hidden]{display:none!important}
      .shopify-section--collection-choice-guide .collection-choice-guide__card{position:relative;display:flex;min-height:100%;flex-direction:column;gap:8px;padding:16px;background:#fff;border:1px solid #e1e6e2;border-radius:8px}
      .shopify-section--collection-choice-guide .collection-choice-guide__card--has-media{min-height:152px;padding-inline-end:96px}
      .shopify-section--collection-choice-guide .collection-choice-guide__media{position:absolute;top:14px;right:14px;display:flex;align-items:center;justify-content:center;width:64px;height:64px;overflow:hidden;background:#fffdf3;border:1px solid #eee4c7;border-radius:6px;box-shadow:0 1px 4px rgba(63,58,57,.08)}
      .shopify-section--collection-choice-guide .collection-choice-guide__media img{display:block;width:100%;height:100%;object-fit:contain}
      @media (max-width:999px){.shopify-section--collection-choice-guide .collection-choice-guide__inner{grid-template-columns:1fr}}
      @media (max-width:699px){.shopify-section--collection-choice-guide .collection-choice-guide__inner{gap:18px}.shopify-section--collection-choice-guide .collection-choice-guide__grid{grid-template-columns:1fr}.shopify-section--collection-choice-guide .collection-choice-guide__card--has-media{min-height:142px;padding-inline-end:82px}.shopify-section--collection-choice-guide .collection-choice-guide__media{width:54px;height:54px}}
    `;
    document.head.appendChild(style);
  };

  const cardHtml = (card, collectionTitle) => `
    <article class="collection-choice-guide__card collection-choice-guide__card--group-${card.group}${card.image ? ' collection-choice-guide__card--has-media' : ''}" data-choice-card data-choice-group="${card.group}">
      <p class="collection-choice-guide__badge">${escapeHtml(card.badge)}</p>
      ${card.image ? `<div class="collection-choice-guide__media"><img src="${escapeHtml(card.image)}" alt="${escapeHtml(card.alt || card.title)}" loading="lazy"></div>` : ''}
      <h3 class="collection-choice-guide__card-title">${escapeHtml(card.title)}</h3>
      <p class="collection-choice-guide__text">${escapeHtml(card.text)}</p>
      <a class="collection-choice-guide__link" href="${escapeHtml(card.link)}" data-collection-choice-link data-collection-handle="${escapeHtml(window.location.pathname.split('/').pop())}" data-collection-title="${escapeHtml(collectionTitle)}" data-card-title="${escapeHtml(card.title)}" data-card-badge="${escapeHtml(card.badge)}" data-link-label="${escapeHtml(card.label)}">${escapeHtml(card.label)} <span aria-hidden="true">&rarr;</span></a>
    </article>
  `;

  const hydrate = () => {
    const guide = guideByPath[window.location.pathname];
    if (!guide) return;

    const section = document.querySelector('.shopify-section--collection-choice-guide');
    if (!section || section.querySelector('[data-choice-tab]')) return;

    const root = section.querySelector('.collection-choice-guide');
    if (!root) return;

    const groups = ['purpose', 'texture', 'wrinkle', 'map'].filter((group) => guide.cards.some((card) => card.group === group));

    root.setAttribute('data-choice-guide-default', 'purpose');
    root.innerHTML = `
      <div class="container">
        <div class="collection-choice-guide__inner">
          <div class="collection-choice-guide__header">
            <p class="collection-choice-guide__subheading">CHOOSING GUIDE</p>
            <h2 class="collection-choice-guide__heading">迷ったら、用途から選べます</h2>
            <div class="collection-choice-guide__content rte"><p>同じカテゴリの中でも、厚み・ハリ・用途で向き不向きがあります。最初に見る候補を絞るための目安です。</p></div>
            <div class="collection-choice-guide__tabs" role="tablist" aria-label="${escapeHtml(guide.collectionTitle)}の選び方">
              ${groups.map((group) => `<button class="collection-choice-guide__tab" type="button" role="tab" aria-selected="${group === 'purpose'}" data-choice-tab="${group}">${labels[group]}</button>`).join('')}
            </div>
          </div>
          <div class="collection-choice-guide__grid">
            ${guide.cards.map((card) => cardHtml(card, guide.collectionTitle)).join('')}
          </div>
        </div>
      </div>
    `;

    injectStyle();

    const tabs = section.querySelectorAll('[data-choice-tab]');
    const cards = section.querySelectorAll('[data-choice-card]');
    const setActiveGroup = (group) => {
      tabs.forEach((tab) => tab.setAttribute('aria-selected', tab.dataset.choiceTab === group ? 'true' : 'false'));
      cards.forEach((card) => {
        card.hidden = card.dataset.choiceGroup !== group;
      });
    };

    tabs.forEach((tab) => tab.addEventListener('click', () => setActiveGroup(tab.dataset.choiceTab)));
    setActiveGroup('purpose');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate, { once: true });
  } else {
    hydrate();
  }
})();
// nunoawase-product-link-correction:start
(function () {
  const rootSelector = '.nunoawase-products';
  const productSelector = rootSelector + ' a[href*="/products/"]';
  const clean = (value) => String(value || '').replace(/[\s\u3000]+/g, ' ').trim();
  const oldSoft = (label) => /[＃#]\s*[a-g]\b/i.test(label) || /(?:^|[\/／])\s*[a-g]\s+(濃レッド|レッド|濃ネイビー|ネイビー|カフェオレ|濃グリーン|グリーン|ブラウン|濃ブラック|ブラック|ローズ)/i.test(label);
  const targetHandle = (rawLabel) => {
    const label = clean(rawLabel);
    if (/綿ポリ.*ハーフダンガリー.*(?:1mm|3mm|6mm|1㎜|3㎜|6㎜).*ギンガム.*地[：:]/.test(label)) return '5557-6667';
    if (/^綿ポリ混紡ハーフダンガリー ギンガム/.test(label)) return 'd100-1';
    if (/色落ちしない 綿ポリデニムストライプ/.test(label)) return '5731-2';
    if (/ラミネート(?:加工)?.*綿ポリ.*ハーフダンガリー/.test(label)) return '66000';
    if (/綿ポリ.*ダンガリー.*藍染風/.test(label)) return '8500';
    if (/綿ポリ.*ダンガリー.*3mmギンガム.*キルト/.test(label)) return '4520-quilt';
    if (!/ソフトダンガリー/.test(label) || oldSoft(label)) return '';
    if (/織ドット/.test(label)) return '7000';
    if (/グレンチェック|[＃#]\s*15|＃15/.test(label)) return '8000-15';
    if (/ウィンドウチェック|[＃#]\s*29/.test(label)) return '8000-29';
    if (/No\.?\s*24|Ｎｏ\.?\s*24|[＃#]\s*24|オリジナルチェック/.test(label)) return '8000-24';
    if (/No\.?\s*28|Ｎｏ\.?\s*28/.test(label)) return '8000-28';
    if (/No\.?\s*23|Ｎｏ\.?\s*23|クラシックチェック[＃#]?\s*23/.test(label)) return '8000-23';
    if (/No\.?\s*19|Ｎｏ\.?\s*19/.test(label)) return '8000-19';
    if (/No\.?\s*20|Ｎｏ\.?\s*20/.test(label)) return '8000-20';
    if (/No\.?\s*22|Ｎｏ\.?\s*22/.test(label)) return '8000-22';
    if (/ピンストライプ|[＃#]\s*18/.test(label)) return '8000-18';
    if (/1\.5mmギンガム/.test(label)) return '8000-12';
    if (/3mmギンガム/.test(label)) return '8000-27';
    if (/5mmギンガム/.test(label)) return '86000';
    if (/5mmストライプ|1\.5mmストライプ/.test(label)) return '8000-11';
    return '';
  };
  const fixLinks = (root = document) => {
    if (!document.querySelector(rootSelector)) return;
    root.querySelectorAll?.(productSelector).forEach((link) => {
      const handle = targetHandle(link.textContent);
      if (!handle) return;
      const url = new URL(link.getAttribute('href'), window.location.origin);
      if (url.pathname !== '/products/' + handle) {
        url.pathname = '/products/' + handle;
        link.href = url.href;
      }
    });
  };
  const init = () => {
    if (!document.querySelector(rootSelector)) return;
    fixLinks(document);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) fixLinks(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
// nunoawase-product-link-correction:end

(() => {
  const marker = 'kit-quantity-unit-client-guard-20260601-v1';
  if (window[marker]) return;
  window[marker] = true;

  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const isKitProductPage = () => /^\/products\/[^/?#]*-kit(?:$|[/?#])/.test(window.location.pathname);

  const normalizeQuantityBlock = (block) => {
    const label = block.querySelector('.label_text');
    if (label && label.textContent.trim() === '長さ') {
      label.textContent = '数量';
    }

    const wrapper = block.querySelector('.quantity-selector-wrapper');
    if (!wrapper) return;

    wrapper.querySelectorAll('select[name="quantity"] option').forEach((option) => {
      const value = option.textContent.replace(/\s+/g, '').trim();
      if (/^\d+$/.test(value)) {
        option.textContent = value + 'セット';
      }
    });

    Array.from(wrapper.children).forEach((child) => {
      if (child.tagName === 'SPAN' && child.textContent.trim() === 'cm') {
        child.remove();
      }
    });
  };

  const normalizeKitQuantity = () => {
    if (!isKitProductPage()) return;
    document
      .querySelectorAll('.product-info__block-item[data-block-id="quantity_selector"], .product-info__block-item[data-block-type="quantity-selector"]')
      .forEach(normalizeQuantityBlock);
  };

  onReady(() => {
    normalizeKitQuantity();
    document.addEventListener('shopify:section:load', normalizeKitQuantity);
  });
})();

// review-request-judgeme-cdn-fallback-20260602
(function () {
  if (window.__reviewRequestJudgeMeFallback) return;
  var normalizedPath = window.location.pathname.replace(/\/$/, "");
  if (normalizedPath !== "/products/review") return;

  window.__reviewRequestJudgeMeFallback = true;
  window.jdgm = window.jdgm || {};
  window.jdgm.CDN_BASE_URL = window.jdgm.CDN_BASE_URL || "https://cdn.shopify.com/extensions/019e74df-668b-769a-ba9e-6cd96fff6c65/judgeme-546/assets/";

  function ensureLoader(forceReload) {
    var container = document.getElementById("judgeme_product_reviews");
    if (!container) return;

    window.jdgm = window.jdgm || {};
    window.jdgm.CDN_BASE_URL = window.jdgm.CDN_BASE_URL || "https://cdn.shopify.com/extensions/019e74df-668b-769a-ba9e-6cd96fff6c65/judgeme-546/assets/";

    if (forceReload && window.jdgm._loaderExecuted && !container.querySelector(".jdgm-rev, .jdgm-row, .jdgm-widget-actions-wrapper")) {
      window.jdgm._loaderExecuted = false;
    }

    if (!forceReload && document.querySelector('script[src*="/judgeme-"][src*="/assets/loader.js"]')) return;

    var loader = document.createElement("script");
    loader.src = "https://cdn.shopify.com/extensions/019e74df-668b-769a-ba9e-6cd96fff6c65/judgeme-546/assets/loader.js";
    loader.type = "text/javascript";
    loader.defer = true;
    loader.setAttribute("data-review-request-custom-loader", "true");
    document.head.appendChild(loader);
  }

  ensureLoader(false);
  window.setTimeout(function () { ensureLoader(true); }, 600);
  window.setTimeout(function () { ensureLoader(true); }, 1800);
})();

// judgeme-star-glyph-fallback-20260604
(function () {
  if (window.__judgeMeStarGlyphFallback) return;
  window.__judgeMeStarGlyphFallback = true;

  var starMap = {
    "\ue000": "\u2605",
    "\ue001": "\u2606",
    "\ue002": "\u2605"
  };

  function normalizeIcon(icon) {
    if (!icon || icon.nodeType !== 1) return;

    var original = icon.textContent || "";
    var normalized = "";
    var changed = false;

    for (var i = 0; i < original.length; i += 1) {
      var char = original.charAt(i);
      if (starMap[char]) {
        normalized += starMap[char];
        changed = true;
      } else {
        normalized += char;
      }
    }

    if (changed) {
      icon.textContent = normalized;
      icon.setAttribute("data-jm-star-glyph-normalized", "true");
    }
  }

  function normalizeJudgeMeStars(root) {
    var scope = root && root.nodeType === 1 ? root : document;

    if (scope.matches && scope.matches(".jm-star-rating__font-icon")) {
      normalizeIcon(scope);
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll("#judgeme_product_reviews .jm-star-rating__font-icon, .jdgm-review-widget .jm-star-rating__font-icon")
        .forEach(normalizeIcon);
    }
  }

  function init() {
    normalizeJudgeMeStars(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "characterData") {
          normalizeJudgeMeStars(mutation.target.parentElement);
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            normalizeJudgeMeStars(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    [500, 1500, 4000].forEach(function (delay) {
      window.setTimeout(function () {
        normalizeJudgeMeStars(document);
      }, delay);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
